import { makeStyles, useTheme } from '@material-ui/styles';

const patternStyle = makeStyles((theme) => ({
  root: { border: 'none' },
}));

export default patternStyle;
